// import { listSchool } from '@utils/constan'
import { NetWorkService, validResponse } from '@utils/API'
import { CODE_SUCCESS } from '@utils/constan'
import { message, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store'
import { setEduBillDetail, setIsHome, setStudenInfor, Type_Initstate } from 'store/appSlice'
import { IGroupDetail } from '../../types/general'
import SchoolItem from './components/SchoolItem'

type OrganizationCard = Pick<IGroupDetail, 'orgCode' | 'orgName' | 'logo'>

const Home = () => {
  const appState = useSelector<RootState, Type_Initstate>((state) => state.app)
  const { listEdubillDetail } = appState
  // console.log('listEdubillDetail', listEdubillDetail)
  const dispatch = useDispatch()
  const [organizations, setOrganizations] = useState<Record<string, OrganizationCard> | null>(null)
  const { Get } = NetWorkService

  useEffect(() => {
    dispatch(setStudenInfor(undefined))
    dispatch(setEduBillDetail(undefined))
    dispatch(setIsHome(true))
  }, [])

  useEffect(() => {
    let active = true

    const getOrganizations = async () => {
      try {
        const res: any = await Get({
          url: '/api/organization/all',
          params: { limit: 99, offset: 0, 'status[eq]': 1 },
        })
        const payload = res?.data?.data
        const records = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.records)
            ? payload.records
            : Array.isArray(payload?.data)
              ? payload.data
              : payload?.data?.records

        if (!res || !validResponse(res) || res.code !== CODE_SUCCESS || payload?.success === false || !Array.isArray(records)) {
          throw new Error('Invalid organization list response')
        }

        if (active) {
          setOrganizations(
            records.reduce((acc: Record<string, OrganizationCard>, organization: IGroupDetail) => {
              if (organization.orgCode) {
                acc[organization.orgCode] = {
                  orgCode: organization.orgCode,
                  orgName: organization.orgName,
                  logo: organization.logo,
                }
              }
              return acc
            }, {}),
          )
        }
      } catch (error) {
        if (active) {
          message.error('Không lấy được danh sách cơ sở đào tạo')
          setOrganizations({})
        }
      }
    }

    getOrganizations()
    return () => {
      active = false
    }
  }, [Get])

  const listEdubillDetailfill = Object.values(
    listEdubillDetail.filter((item) => item.status !== 0).reduce((acc, cur) => {
      const code = cur.orgCode

      if (!acc[code]) {
        acc[code] = {
          ...cur,
          children: 1,
        }
      } else {
        acc[code].children += 1
      }

      return acc
    }, {} as Record<string, any>),
  )
  return (
    <div className="pb-6">
      <div className="md:text-[22px] text-[16px] font-bold text-center md:mt-[10vh] mt-[4vh] text-[#045993]">
        Chọn trường
      </div>
      <div className="md:text-[18px] text-[16px] text-center mt-3">
        Vui lòng chọn trường để tiếp tục tra cứu thông tin học phí
      </div>
      <div className="flex justify-center items-start gap-[37px] self-stretch mt-10 flex-wrap">
        {/* {listSchool.map((e, i) => (
          <SchoolItem item={e} key={i} />
        ))} */}

        {organizations === null ? (
          <Spin />
        ) : (
          listEdubillDetailfill.map((e) => (
            <SchoolItem item={e} organization={organizations[e.orgCode]} key={e.orgCode} />
          ))
        )}
      </div>
    </div>
  )
}
export default Home
